var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1171275937(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 773,
    height: 1220,
    viewBox: "0 0 773 1220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M371.737 211.171L278.292 218.641L247.62 135.424L242.083 112.51L396.026 117.915L371.737 211.171Z",
    fill: "#F18555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M312.384 603.807L432.731 565.557L461.239 671.372L457.459 670.562L312.384 603.807Z",
    fill: "#B71547",
    fillOpacity: 0.69
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M404.669 774.36L428.179 848.12L433.117 847.069L473.114 790.151L404.669 774.36Z",
    fill: "#BEA751"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M398.356 932.433L348.138 845.659L90.1123 848.492L293.06 920.668L398.356 932.433Z",
    fill: "#5ABDC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.397 732.717C387.677 731.689 387.92 730.267 388.938 729.539C389.957 728.812 391.365 729.054 392.084 730.081C392.804 731.109 392.561 732.531 391.543 733.259C390.524 733.985 389.116 733.744 388.397 732.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.1 801.257C331.38 800.231 331.622 798.809 332.641 798.081C333.66 797.353 335.068 797.596 335.787 798.623C336.507 799.65 336.264 801.071 335.246 801.799C334.228 802.527 332.82 802.284 332.1 801.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.255 898.419C481.537 897.391 481.778 895.97 482.796 895.242C483.815 894.514 485.224 894.757 485.944 895.784C486.663 896.811 486.421 898.232 485.402 898.96C484.384 899.688 482.975 899.446 482.255 898.419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.514 874.362C243.795 873.336 244.037 871.913 245.055 871.185C246.073 870.457 247.482 870.702 248.202 871.728C248.921 872.754 248.679 874.178 247.66 874.905C246.643 875.632 245.234 875.389 244.514 874.362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.71 967.704C269.99 966.677 270.233 965.256 271.25 964.528C272.269 963.801 273.677 964.043 274.397 965.071C275.116 966.096 274.874 967.52 273.856 968.247C272.838 968.974 271.43 968.732 270.71 967.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.006 958.384C353.287 957.356 353.529 955.935 354.547 955.207C355.566 954.479 356.974 954.722 357.694 955.749C358.413 956.776 358.17 958.198 357.153 958.925C356.135 959.653 354.726 959.41 354.006 958.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5306 937.033C14.8107 936.007 15.0523 934.584 16.071 933.857C17.0886 933.13 18.4969 933.373 19.2168 934.399C19.9366 935.426 19.694 936.849 18.6773 937.576C17.6587 938.303 16.2494 938.06 15.5306 937.033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.796 957.663C128.076 956.635 128.318 955.213 129.337 954.485C130.354 953.758 131.763 954.001 132.483 955.027C133.202 956.054 132.96 957.476 131.942 958.204C130.924 958.931 129.516 958.688 128.796 957.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8242 848.423L246.364 872.888",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.401 873.047L130.594 956.345",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.637 956.301L89.8201 848.309",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19 959.92L189.434 1102.1",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.434 1101.97L10.7692 1044.32",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.687 956.345L10.7267 1044.13",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.636 956.475L272.551 966.257",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.551 966.361L246.358 873.074",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.551 966.388L355.853 957.066",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.848 956.947L246.362 873.164",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.351 873.047L431.852 846.262",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.89 846.261L355.789 957.066",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.847 957.204L494.692 975.627",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.692 975.698L431.835 846.329",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.827 846.262L530.526 837.724",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.599 837.724L494.625 975.766",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.528 837.572L390.283 732.104",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.282 731.993L428.676 848.968",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.833 846.156L333.941 800.044",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.981 799.94L246.324 873.047",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.637 956.229L17.3711 935.832",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4271 935.716L10.7163 1044.13",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.394 1102.16L354.545 1025.14",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.184 1022.57L272.554 966.481",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.626 966.388L189.367 1102.16",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.557 1025.14L295.927 1125.68",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.436 1102.22L245.958 1161.37",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.28 732.005L556.903 731.404",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.303 806.209L560.136 729.176",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.82 957.065L484.125 897.101",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.066 897.102L530.552 837.724",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4714 849.271L216.989 994.901",
    stroke: "url(#paint0_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.098 992.732L15.8881 963.084",
    stroke: "url(#paint1_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.96 994.982L292.8 920.441",
    stroke: "url(#paint2_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.81 920.441L271.092 1022.92",
    stroke: "url(#paint3_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.13 1022.89L216.988 995.015",
    stroke: "url(#paint4_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.029 994.981L189.517 1102.29",
    stroke: "url(#paint5_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.559 1102.18L15.7798 965.203",
    stroke: "url(#paint6_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7804 965.145L97.7234 1114.09",
    stroke: "url(#paint7_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7215 1114.2L185.505 1167.26",
    stroke: "url(#paint8_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.487 1167.32L189.587 1102.29",
    stroke: "url(#paint9_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.563 1102.29L100.991 1118.83",
    stroke: "url(#paint10_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.033 1163.8L219.356 1180.24",
    stroke: "url(#paint11_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.052 1163.78L166.192 1218.25",
    stroke: "url(#paint12_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.008 1163.78L251.893 1109.27",
    stroke: "url(#paint13_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.872 1109.23L189.559 1102.33",
    stroke: "url(#paint14_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.527 1102.29L271.16 1022.92",
    stroke: "url(#paint15_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.163 1022.92L251.838 1109.27",
    stroke: "url(#paint16_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.131 1022.96L354.684 1025.13",
    stroke: "url(#paint17_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.717 1025.17L251.841 1109.27",
    stroke: "url(#paint18_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.876 1109.28L279.091 1125.03",
    stroke: "url(#paint19_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.684 1025.06L190.137 762.651",
    stroke: "url(#paint20_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.674 1025.17L452.905 995.526",
    stroke: "url(#paint21_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.647 1025.17L398.101 932.206",
    stroke: "url(#paint22_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.067 932.146L292.772 920.503",
    stroke: "url(#paint23_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.772 920.48L354.684 1025.13",
    stroke: "url(#paint24_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.071 932.207L495.647 929.74",
    stroke: "url(#paint25_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.671 929.74L452.871 995.525",
    stroke: "url(#paint26_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.895 995.488L394.425 932.54",
    stroke: "url(#paint27_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.637 929.74L568.709 907.455",
    stroke: "url(#paint28_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.645 929.699L431.841 846.122",
    stroke: "url(#paint29_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.87 846.081L398.033 932.207",
    stroke: "url(#paint30_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.067 932.175L347.849 845.464",
    stroke: "url(#paint31_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.879 845.431L292.745 920.44",
    stroke: "url(#paint32_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.77 920.314L90.47 849.317",
    stroke: "url(#paint33_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4755 849.191L219.165 847.311L347.853 845.432",
    stroke: "url(#paint34_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.82 845.432L409.125 773.973",
    stroke: "url(#paint35_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.852 845.462L431.841 846.051",
    stroke: "url(#paint36_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.824 846.081L489.566 810.145",
    stroke: "url(#paint37_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.555 810.17L530.364 837.634",
    stroke: "url(#paint38_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.398 837.66L495.608 929.74",
    stroke: "url(#paint39_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 837.684L568.7 907.43",
    stroke: "url(#paint40_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.364 837.657L524.704 749.381",
    stroke: "url(#paint41_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.727 749.378L489.532 810.145",
    stroke: "url(#paint42_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.551 810.094L409.098 774.024",
    stroke: "url(#paint43_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3208 850.77C84.9523 848.817 85.413 846.113 87.3488 844.729C89.2856 843.347 91.9632 843.809 93.3317 845.761C94.6992 847.715 94.2395 850.419 92.3027 851.802C90.3668 853.184 87.6883 852.722 86.3208 850.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.484 997.486C212.117 995.533 212.576 992.83 214.513 991.446C216.45 990.064 219.129 990.525 220.496 992.478C221.864 994.431 221.403 997.134 219.468 998.518C217.532 999.9 214.853 999.439 213.484 997.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.592 776.476C404.224 774.525 404.685 771.82 406.622 770.437C408.557 769.055 411.236 769.516 412.605 771.469C413.973 773.421 413.513 776.126 411.577 777.508C409.64 778.892 406.961 778.43 405.592 776.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.342 847.937C342.974 845.984 343.435 843.28 345.373 841.896C347.308 840.514 349.987 840.976 351.355 842.929C352.723 844.881 352.263 847.585 350.327 848.968C348.391 850.351 345.711 849.889 344.342 847.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.046 812.649C484.678 810.697 485.139 807.993 487.075 806.61C489.012 805.226 491.69 805.688 493.058 807.642C494.426 809.594 493.966 812.298 492.031 813.681C490.093 815.063 487.414 814.603 486.046 812.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.326 848.586C426.96 846.633 427.419 843.928 429.356 842.546C431.291 841.164 433.971 841.625 435.339 843.576C436.708 845.529 436.247 848.235 434.31 849.617C432.374 851 429.695 850.539 428.326 848.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.851 840.164C525.483 838.212 525.944 835.507 527.88 834.125C529.816 832.741 532.494 833.203 533.863 835.156C535.231 837.109 534.77 839.813 532.834 841.195C530.897 842.578 528.219 842.117 526.851 840.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.132 932.244C490.765 930.292 491.226 927.588 493.162 926.204C495.097 924.822 497.776 925.283 499.144 927.236C500.512 929.189 500.052 931.893 498.117 933.275C496.18 934.659 493.501 934.197 492.132 932.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.561 934.709C393.192 932.757 393.653 930.052 395.591 928.669C397.526 927.287 400.206 927.748 401.574 929.701C402.942 931.653 402.482 934.358 400.545 935.74C398.608 937.125 395.929 936.663 394.561 934.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.381 998.03C448.013 996.077 448.473 993.373 450.411 991.99C452.346 990.608 455.026 991.069 456.394 993.021C457.762 994.975 457.302 997.678 455.365 999.061C453.429 1000.44 450.749 999.983 449.381 998.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.186 909.959C563.819 908.007 564.28 905.303 566.217 903.919C568.152 902.536 570.831 902.998 572.198 904.95C573.567 906.904 573.107 909.608 571.171 910.991C569.234 912.374 566.556 911.913 565.186 909.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.193 751.882C519.827 749.929 520.287 747.225 522.224 745.843C524.16 744.459 526.839 744.921 528.207 746.873C529.574 748.826 529.115 751.53 527.178 752.913C525.241 754.296 522.563 753.835 521.193 751.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.179 1027.67C349.811 1025.72 350.271 1023.01 352.208 1021.63C354.144 1020.25 356.823 1020.71 358.191 1022.66C359.559 1024.62 359.099 1027.32 357.162 1028.7C355.226 1030.09 352.547 1029.62 351.179 1027.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.366 1111.77C246.999 1109.82 247.46 1107.11 249.396 1105.73C251.333 1104.35 254.01 1104.81 255.379 1106.76C256.746 1108.71 256.287 1111.42 254.35 1112.8C252.413 1114.18 249.736 1113.72 248.366 1111.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.054 1104.79C184.688 1102.84 185.147 1100.14 187.084 1098.75C189.021 1097.37 191.698 1097.83 193.066 1099.78C194.434 1101.74 193.974 1104.44 192.036 1105.82C190.1 1107.21 187.423 1106.74 186.054 1104.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.625 1025.43C266.256 1023.47 266.717 1020.77 268.654 1019.39C270.59 1018 273.269 1018.47 274.636 1020.42C276.004 1022.37 275.545 1025.08 273.607 1026.46C271.672 1027.84 268.992 1027.38 267.625 1025.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.266 922.945C287.897 920.992 288.358 918.288 290.294 916.906C292.231 915.522 294.909 915.984 296.277 917.936C297.645 919.889 297.185 922.594 295.248 923.976C293.312 925.36 290.633 924.898 289.266 922.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 967.597C10.9051 965.643 11.366 962.94 13.302 961.558C15.239 960.174 17.9167 960.637 19.2851 962.588C20.6526 964.541 20.1927 967.245 18.2558 968.629C16.3197 970.012 13.6421 969.55 12.2736 967.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.524 1166.28C178.155 1164.33 178.616 1161.62 180.552 1160.24C182.489 1158.86 185.167 1159.32 186.535 1161.27C187.903 1163.22 187.443 1165.93 185.506 1167.31C183.57 1168.69 180.892 1168.23 179.524 1166.28Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213.484 997.486C212.117 995.533 212.576 992.83 214.513 991.446C216.45 990.064 219.129 990.525 220.496 992.478C221.864 994.431 221.403 997.134 219.468 998.518C217.532 999.9 214.853 999.439 213.484 997.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.592 776.476C404.224 774.525 404.685 771.82 406.622 770.437C408.557 769.055 411.236 769.516 412.605 771.469C413.973 773.421 413.513 776.126 411.577 777.508C409.64 778.892 406.961 778.43 405.592 776.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.342 847.937C342.974 845.984 343.435 843.28 345.373 841.896C347.308 840.514 349.987 840.976 351.355 842.929C352.723 844.881 352.263 847.585 350.327 848.968C348.391 850.351 345.711 849.889 344.342 847.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.046 812.649C484.678 810.697 485.139 807.993 487.075 806.61C489.012 805.226 491.69 805.688 493.058 807.642C494.426 809.594 493.966 812.298 492.031 813.681C490.093 815.063 487.414 814.603 486.046 812.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.326 848.586C426.96 846.633 427.419 843.928 429.356 842.546C431.291 841.164 433.971 841.625 435.339 843.576C436.708 845.529 436.247 848.235 434.31 849.617C432.374 851 429.695 850.539 428.326 848.586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.851 840.164C525.483 838.212 525.944 835.507 527.88 834.125C529.816 832.741 532.494 833.203 533.863 835.156C535.231 837.109 534.77 839.813 532.834 841.195C530.897 842.578 528.219 842.117 526.851 840.164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.132 932.244C490.765 930.292 491.226 927.588 493.162 926.204C495.097 924.822 497.776 925.283 499.144 927.236C500.512 929.189 500.052 931.893 498.117 933.275C496.18 934.659 493.501 934.197 492.132 932.244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.561 934.709C393.192 932.757 393.653 930.052 395.591 928.669C397.526 927.287 400.206 927.748 401.574 929.701C402.942 931.653 402.482 934.358 400.545 935.74C398.608 937.125 395.929 936.663 394.561 934.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.381 998.03C448.013 996.077 448.473 993.373 450.411 991.99C452.346 990.608 455.026 991.069 456.394 993.021C457.762 994.975 457.302 997.678 455.365 999.061C453.429 1000.44 450.749 999.983 449.381 998.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.186 909.959C563.819 908.007 564.28 905.303 566.217 903.919C568.152 902.536 570.831 902.998 572.198 904.95C573.567 906.904 573.107 909.608 571.171 910.991C569.234 912.374 566.556 911.913 565.186 909.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.193 751.882C519.827 749.929 520.287 747.225 522.224 745.843C524.16 744.459 526.839 744.921 528.207 746.873C529.574 748.826 529.115 751.53 527.178 752.913C525.241 754.296 522.563 753.835 521.193 751.882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.179 1027.67C349.811 1025.72 350.271 1023.01 352.208 1021.63C354.144 1020.25 356.823 1020.71 358.191 1022.66C359.559 1024.62 359.099 1027.32 357.162 1028.7C355.226 1030.09 352.547 1029.62 351.179 1027.67Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.366 1111.77C246.999 1109.82 247.46 1107.11 249.396 1105.73C251.333 1104.35 254.01 1104.81 255.379 1106.76C256.746 1108.71 256.287 1111.42 254.35 1112.8C252.413 1114.18 249.736 1113.72 248.366 1111.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.054 1104.79C184.688 1102.84 185.147 1100.14 187.084 1098.75C189.021 1097.37 191.698 1097.83 193.066 1099.78C194.434 1101.74 193.974 1104.44 192.036 1105.82C190.1 1107.21 187.423 1106.74 186.054 1104.79Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.625 1025.43C266.256 1023.47 266.717 1020.77 268.654 1019.39C270.59 1018 273.269 1018.47 274.636 1020.42C276.004 1022.37 275.545 1025.08 273.607 1026.46C271.672 1027.84 268.992 1027.38 267.625 1025.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.266 922.945C287.897 920.992 288.358 918.288 290.294 916.906C292.231 915.522 294.909 915.984 296.277 917.936C297.645 919.889 297.185 922.594 295.248 923.976C293.312 925.36 290.633 924.898 289.266 922.945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2736 967.597C10.9051 965.643 11.366 962.94 13.302 961.558C15.239 960.174 17.9167 960.637 19.2851 962.588C20.6526 964.541 20.1927 967.245 18.2558 968.629C16.3197 970.012 13.6421 969.55 12.2736 967.597Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.524 1166.28C178.155 1164.33 178.616 1161.62 180.552 1160.24C182.489 1158.86 185.167 1159.32 186.535 1161.27C187.903 1163.22 187.443 1165.93 185.506 1167.31C183.57 1168.69 180.892 1168.23 179.524 1166.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.379 262.227C264.168 263.468 263 264.301 261.771 264.091C260.542 263.879 259.717 262.703 259.929 261.461C260.141 260.222 261.308 259.385 262.537 259.597C263.765 259.812 264.59 260.988 264.379 262.227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.153 253.991C351.942 255.231 350.776 256.065 349.546 255.853C348.317 255.642 347.492 254.466 347.703 253.225C347.916 251.984 349.083 251.15 350.311 251.362C351.54 251.573 352.363 252.751 352.153 253.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.965 77.9941C313.751 79.2336 312.585 80.069 311.358 79.8568C310.129 79.6447 309.303 78.4668 309.514 77.2263C309.726 75.9869 310.893 75.1534 312.121 75.3646C313.351 75.5777 314.177 76.7537 313.965 77.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.238 264.88C465.027 266.119 463.861 266.954 462.632 266.742C461.404 266.53 460.579 265.352 460.79 264.112C461.002 262.872 462.169 262.037 463.398 262.249C464.625 262.461 465.45 263.637 465.238 264.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.027 180.16C511.817 181.399 510.649 182.233 509.422 182.022C508.192 181.81 507.367 180.634 507.579 179.393C507.791 178.153 508.958 177.318 510.186 177.531C511.415 177.742 512.24 178.918 512.027 180.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.606 127.234C446.395 128.474 445.229 129.307 444 129.096C442.772 128.884 441.945 127.708 442.158 126.467C442.369 125.226 443.537 124.393 444.765 124.605C445.993 124.816 446.817 125.993 446.606 127.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.746 316.714C654.535 317.953 653.368 318.789 652.14 318.577C650.911 318.364 650.087 317.187 650.298 315.947C650.51 314.707 651.677 313.873 652.904 314.084C654.133 314.295 654.958 315.471 654.746 316.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.309 262.893C602.097 264.135 600.931 264.969 599.702 264.756C598.474 264.546 597.65 263.368 597.86 262.127C598.072 260.889 599.238 260.053 600.466 260.265C601.695 260.477 602.519 261.655 602.309 262.893Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.356 393.774L463.008 264.596",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.012 264.495L600.085 262.511",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.149 262.512L556.292 393.874",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.39 258.919L663.645 143.165",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.581 143.239L733.051 244.312",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.073 262.511L733.063 244.386",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.083 262.414L509.804 179.872",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.849 179.776L462.969 264.495",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.801 179.706L444.382 126.921",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.386 126.869L463.012 264.477",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.012 264.335L313.121 151.066",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.106 150.905L444.396 126.85",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.387 126.759L359.293 14.5077",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.357 14.4165L313.048 150.905",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.122 150.824L237.362 86.5028",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.326 86.4218L359.331 14.417",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.357 86.4464L262.512 261.402",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.459 261.427L317.33 151.221",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.121 150.944L349.926 253.569",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.926 253.715L463.012 264.388",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.083 262.568L652.52 316.275",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.485 316.331L733.093 244.386",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.583 142.985L492.968 79.8526",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.628 78.8179L509.801 179.754",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.789 179.776L663.605 143.165",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.954 79.6731L604.719 50.4032",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.548 143.165L665.129 60.8675",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.512 261.3L144.346 142.842",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.018 136.705L140.494 142.046",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.387 126.73L311.742 77.732",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74 77.6121L237.352 86.4217",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.481 392.756L569.174 199.264",
    stroke: "url(#paint44_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.106 199.331L674.208 296.63",
    stroke: "url(#paint45_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.106 199.222L463.362 197.864",
    stroke: "url(#paint46_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.338 197.82L550.394 140.818",
    stroke: "url(#paint47_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.375 140.83L569.106 199.252",
    stroke: "url(#paint48_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.087 199.264L663.613 142.985",
    stroke: "url(#paint49_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.589 142.991L674.208 296.691",
    stroke: "url(#paint50_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.168 296.697L736.858 200.223",
    stroke: "url(#paint51_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.825 200.208L711.96 99.9164",
    stroke: "url(#paint52_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.979 99.9009L663.576 142.986",
    stroke: "url(#paint53_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.585 143.033L737.778 194.527",
    stroke: "url(#paint54_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.231 104.164L697.085 66.5687",
    stroke: "url(#paint55_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.224 104.172L761.251 77.6766",
    stroke: "url(#paint56_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.231 104.121L624.407 93.5769",
    stroke: "url(#paint57_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.411 93.5515L663.591 142.961",
    stroke: "url(#paint58_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663.591 142.937L550.376 140.868",
    stroke: "url(#paint59_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.354 140.818L624.425 93.5262",
    stroke: "url(#paint60_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.372 140.781L492.861 79.5635",
    stroke: "url(#paint61_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.865 79.6039L624.411 93.4504",
    stroke: "url(#paint62_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.411 93.5217L616.214 62.9242",
    stroke: "url(#paint63_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.852 79.5272L541.102 42.6153",
    stroke: "url(#paint64_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.864 79.4709L402.678 30.3712",
    stroke: "url(#paint65_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.878 79.5272L397.127 114.262",
    stroke: "url(#paint66_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.141 114.305L463.364 197.779",
    stroke: "url(#paint67_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.314 197.821L492.906 79.5277",
    stroke: "url(#paint68_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.137 114.218L326.416 46.3284",
    stroke: "url(#paint69_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.412 46.2832L402.685 30.3138",
    stroke: "url(#paint70_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.705 30.3146L399.893 116.657",
    stroke: "url(#paint71_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.419 46.2405L259.167 9.88363",
    stroke: "url(#paint72_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.458 46.2831L312.958 151.032",
    stroke: "url(#paint73_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.982 151.032L397.154 114.263",
    stroke: "url(#paint74_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.174 114.263L371.889 211.505",
    stroke: "url(#paint75_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.921 211.506L463.365 197.821",
    stroke: "url(#paint76_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.361 197.879L556.551 392.697",
    stroke: "url(#paint77_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.551 392.638L371.927 211.622",
    stroke: "url(#paint78_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.933 211.505L278.615 218.267",
    stroke: "url(#paint79_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.926 211.468L312.993 151.07",
    stroke: "url(#paint80_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.997 150.991L247.039 135.242",
    stroke: "url(#paint81_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.036 135.197L237.434 86.5932",
    stroke: "url(#paint82_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.419 86.5868L326.433 46.2832",
    stroke: "url(#paint83_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.405 86.5869L259.194 9.84156",
    stroke: "url(#paint84_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.463 86.5864L179.64 153.055",
    stroke: "url(#paint85_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.653 153.056L247.04 135.202",
    stroke: "url(#paint86_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.036 135.222L278.614 218.247",
    stroke: "url(#paint87_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.595 394.603C560.193 396.963 557.973 398.548 555.637 398.145C553.3 397.742 551.732 395.504 552.134 393.144C552.536 390.784 554.753 389.199 557.092 389.603C559.428 390.006 560.997 392.244 560.595 394.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M573.338 199.992C572.934 202.352 570.716 203.937 568.379 203.533C566.041 203.131 564.473 200.892 564.876 198.535C565.278 196.175 567.496 194.591 569.833 194.991C572.169 195.394 573.738 197.634 573.338 199.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.845 218.998C282.445 221.354 280.224 222.942 277.887 222.538C275.553 222.135 273.983 219.898 274.384 217.539C274.786 215.179 277.008 213.594 279.343 213.996C281.679 214.399 283.248 216.639 282.845 218.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.158 212.233C375.757 214.592 373.537 216.178 371.198 215.775C368.863 215.373 367.293 213.134 367.698 210.775C368.099 208.415 370.319 206.83 372.654 207.234C374.99 207.636 376.559 209.875 376.158 212.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.267 135.932C250.866 138.29 248.646 139.876 246.31 139.474C243.972 139.071 242.404 136.832 242.807 134.473C243.209 132.114 245.429 130.529 247.763 130.931C250.1 131.335 251.668 133.573 251.267 135.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.228 151.761C316.825 154.118 314.605 155.706 312.268 155.302C309.935 154.899 308.364 152.66 308.765 150.302C309.167 147.944 311.388 146.357 313.724 146.761C316.062 147.163 317.63 149.403 317.228 151.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.665 87.3159C241.263 89.6746 239.044 91.2602 236.709 90.8566C234.371 90.4539 232.803 88.214 233.205 85.8573C233.607 83.4985 235.826 81.9119 238.163 82.3145C240.499 82.7182 242.068 84.9551 241.665 87.3159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.65 47.0137C330.248 49.3714 328.029 50.9571 325.691 50.5554C323.355 50.1538 321.787 47.9138 322.188 45.556C322.592 43.1962 324.811 41.6106 327.146 42.0133C329.483 42.416 331.052 44.6549 330.65 47.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.368 114.993C400.967 117.351 398.747 118.937 396.41 118.533C394.075 118.131 392.504 115.893 392.908 113.533C393.31 111.174 395.529 109.59 397.865 109.992C400.203 110.392 401.771 112.632 401.368 114.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.908 31.0434C406.506 33.4022 404.286 34.9878 401.948 34.5841C399.614 34.1805 398.045 31.9416 398.446 29.5838C398.85 27.225 401.068 25.6394 403.405 26.0421C405.741 26.4447 407.309 28.6836 406.908 31.0434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4 10.5711C262.998 12.9279 260.779 14.5144 258.441 14.1118C256.105 13.7102 254.535 11.4713 254.938 9.11346C255.341 6.75367 257.561 5.16709 259.897 5.57175C262.232 5.97341 263.802 8.21128 263.4 10.5711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.892 153.786C183.489 156.142 181.269 157.729 178.933 157.325C176.598 156.923 175.028 154.685 175.431 152.326C175.832 149.968 178.052 148.382 180.39 148.784C182.725 149.188 184.295 151.425 183.892 153.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.095 80.2585C496.692 82.6173 494.473 84.2029 492.137 83.8003C489.8 83.3976 488.232 81.1587 488.633 78.7999C489.038 76.4421 491.256 74.8565 493.592 75.2592C495.929 75.6598 497.496 77.8997 497.095 80.2585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.642 94.2568C628.241 96.6156 626.019 98.2002 623.684 97.7986C621.346 97.3959 619.779 95.158 620.181 92.7972C620.584 90.4404 622.803 88.8528 625.138 89.2575C627.475 89.6601 629.043 91.897 628.642 94.2568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.821 143.718C667.421 146.074 665.201 147.661 662.865 147.258C660.527 146.855 658.96 144.617 659.362 142.259C659.765 139.899 661.984 138.313 664.32 138.717C666.657 139.119 668.224 141.358 667.821 143.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.603 141.548C554.202 143.906 551.982 145.492 549.644 145.089C547.309 144.687 545.74 142.449 546.141 140.09C546.545 137.731 548.764 136.144 551.102 136.547C553.437 136.951 555.005 139.19 554.603 141.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.595 198.55C467.194 200.909 464.974 202.494 462.638 202.093C460.3 201.69 458.733 199.452 459.134 197.092C459.537 194.733 461.757 193.147 464.092 193.551C466.429 193.953 467.997 196.191 467.595 198.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.438 297.426C678.038 299.785 675.817 301.371 673.483 300.967C671.145 300.565 669.577 298.326 669.979 295.968C670.381 293.61 672.6 292.023 674.937 292.426C677.274 292.828 678.842 295.066 678.438 297.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.462 104.904C715.061 107.263 712.841 108.848 710.506 108.446C708.169 108.042 706.601 105.804 707.002 103.445C707.404 101.087 709.624 99.501 711.961 99.9037C714.297 100.305 715.866 102.544 715.462 104.904Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M573.338 199.992C572.934 202.352 570.716 203.937 568.379 203.533C566.041 203.131 564.473 200.892 564.876 198.535C565.278 196.175 567.496 194.591 569.833 194.991C572.169 195.394 573.738 197.634 573.338 199.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.845 218.998C282.445 221.354 280.224 222.942 277.887 222.538C275.553 222.135 273.983 219.898 274.384 217.539C274.786 215.179 277.008 213.594 279.343 213.996C281.679 214.399 283.248 216.639 282.845 218.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.158 212.233C375.757 214.592 373.537 216.178 371.198 215.775C368.863 215.373 367.293 213.134 367.698 210.775C368.099 208.415 370.319 206.83 372.654 207.234C374.99 207.636 376.559 209.875 376.158 212.233Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.267 135.932C250.866 138.29 248.646 139.876 246.31 139.474C243.972 139.071 242.404 136.832 242.807 134.473C243.209 132.114 245.429 130.529 247.763 130.931C250.1 131.335 251.668 133.573 251.267 135.932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.228 151.761C316.825 154.118 314.605 155.706 312.268 155.302C309.935 154.899 308.364 152.66 308.765 150.302C309.167 147.944 311.388 146.357 313.724 146.761C316.062 147.163 317.63 149.403 317.228 151.761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.665 87.3159C241.263 89.6746 239.044 91.2602 236.709 90.8566C234.371 90.4539 232.803 88.214 233.205 85.8573C233.607 83.4985 235.826 81.9119 238.163 82.3145C240.499 82.7182 242.068 84.9551 241.665 87.3159Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.65 47.0137C330.248 49.3714 328.029 50.9571 325.691 50.5554C323.355 50.1538 321.787 47.9138 322.188 45.556C322.592 43.1962 324.811 41.6106 327.146 42.0133C329.483 42.416 331.052 44.6549 330.65 47.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.368 114.993C400.967 117.351 398.747 118.937 396.41 118.533C394.075 118.131 392.504 115.893 392.908 113.533C393.31 111.174 395.529 109.59 397.865 109.992C400.203 110.392 401.771 112.632 401.368 114.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.908 31.0434C406.506 33.4022 404.286 34.9878 401.948 34.5841C399.614 34.1805 398.045 31.9416 398.446 29.5838C398.85 27.225 401.068 25.6394 403.405 26.0421C405.741 26.4447 407.309 28.6836 406.908 31.0434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4 10.5711C262.998 12.9279 260.779 14.5144 258.441 14.1118C256.105 13.7102 254.535 11.4713 254.938 9.11346C255.341 6.75367 257.561 5.16709 259.897 5.57175C262.232 5.97341 263.802 8.21128 263.4 10.5711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.892 153.786C183.489 156.142 181.269 157.729 178.933 157.325C176.598 156.923 175.028 154.685 175.431 152.326C175.832 149.968 178.052 148.382 180.39 148.784C182.725 149.188 184.295 151.425 183.892 153.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.095 80.2585C496.692 82.6173 494.473 84.2029 492.137 83.8003C489.8 83.3976 488.232 81.1587 488.633 78.7999C489.038 76.4421 491.256 74.8565 493.592 75.2592C495.929 75.6598 497.496 77.8997 497.095 80.2585Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.642 94.2568C628.241 96.6156 626.019 98.2002 623.684 97.7986C621.346 97.3959 619.779 95.158 620.181 92.7972C620.584 90.4404 622.803 88.8528 625.138 89.2575C627.475 89.6601 629.043 91.897 628.642 94.2568Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.821 143.718C667.421 146.074 665.201 147.661 662.865 147.258C660.527 146.855 658.96 144.617 659.362 142.259C659.765 139.899 661.984 138.313 664.32 138.717C666.657 139.119 668.224 141.358 667.821 143.718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.603 141.548C554.202 143.906 551.982 145.492 549.644 145.089C547.309 144.687 545.74 142.449 546.141 140.09C546.545 137.731 548.764 136.144 551.102 136.547C553.437 136.951 555.005 139.19 554.603 141.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.595 198.55C467.194 200.909 464.974 202.494 462.638 202.093C460.3 201.69 458.733 199.452 459.134 197.092C459.537 194.733 461.757 193.147 464.092 193.551C466.429 193.953 467.997 196.191 467.595 198.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.438 297.426C678.038 299.785 675.817 301.371 673.483 300.967C671.145 300.565 669.577 298.326 669.979 295.968C670.381 293.61 672.6 292.023 674.937 292.426C677.274 292.828 678.842 295.066 678.438 297.426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.462 104.904C715.061 107.263 712.841 108.848 710.506 108.446C708.169 108.042 706.601 105.804 707.002 103.445C707.404 101.087 709.624 99.501 711.961 99.9037C714.297 100.305 715.866 102.544 715.462 104.904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.029 349.301C481.784 349.237 480.827 348.167 480.891 346.909C480.956 345.653 482.018 344.685 483.263 344.75C484.508 344.814 485.466 345.884 485.401 347.141C485.336 348.399 484.274 349.365 483.029 349.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.475 436.404C500.229 436.342 499.273 435.271 499.338 434.014C499.403 432.756 500.463 431.79 501.71 431.853C502.955 431.917 503.912 432.988 503.847 434.244C503.782 435.502 502.72 436.468 501.475 436.404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.912 377.324C668.667 377.261 667.71 376.191 667.774 374.933C667.839 373.676 668.901 372.709 670.147 372.772C671.392 372.836 672.349 373.907 672.284 375.163C672.219 376.421 671.157 377.388 669.912 377.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.115 551.168C502.869 551.104 501.913 550.033 501.978 548.777C502.042 547.52 503.104 546.554 504.35 546.617C505.595 546.681 506.551 547.751 506.487 549.007C506.422 550.265 505.36 551.232 504.115 551.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.888 588.129C591.644 588.066 590.687 586.995 590.751 585.739C590.817 584.482 591.878 583.516 593.124 583.579C594.368 583.643 595.326 584.713 595.261 585.97C595.197 587.227 594.133 588.193 592.888 588.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.179 516.239C635.933 516.175 634.976 515.105 635.041 513.848C635.106 512.591 636.168 511.625 637.413 511.688C638.657 511.752 639.615 512.823 639.55 514.079C639.486 515.335 638.424 516.303 637.179 516.239Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.537 747.45C474.291 747.386 473.335 746.317 473.4 745.06C473.464 743.803 474.526 742.836 475.771 742.899C477.017 742.964 477.974 744.035 477.909 745.29C477.844 746.547 476.781 747.514 475.537 747.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.24 688.482C520.994 688.418 520.037 687.348 520.102 686.091C520.167 684.834 521.229 683.867 522.473 683.931C523.719 683.994 524.677 685.065 524.612 686.323C524.547 687.578 523.485 688.547 522.24 688.482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.051 657.829L504.288 548.893",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.228 548.911L522.348 686.188",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.348 686.067L388.104 657.968",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.036 687.282L647.114 735.719",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.157 735.848L555.801 817.501",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.351 686.241L555.848 817.466",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.299 686.206L593.053 585.854",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.997 585.759L504.226 548.987",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.965 585.854L637.332 513.964",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.307 513.964L504.208 548.892",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.143 548.892L598.249 385.079",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.167 385.121L637.294 513.923",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.244 513.964L737.791 415.31",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.739 415.165L598.168 385.224",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.126 385.079L652.642 301.452",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.598 301.543L737.739 415.218",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.619 301.452L483.568 347.339",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.593 347.461L598.348 389.166",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.191 385.079L501.561 434.131",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.588 434.132L504.231 548.891",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.379 686.206L475.617 745.176",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.65 745.263L555.848 817.414",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.026 735.848L689.474 557.152",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.75 552.697L592.982 585.854",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.996 585.912L647.114 735.79",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.38 557.197L731.325 665.775",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.111 735.849L728.168 727.65",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.521 347.339L586.371 214.757",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.848 313.039L586.503 210.829",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.225 513.964L670.094 375.049",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.028 375.033L652.595 301.467",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.224 657.887L580.855 647.659",
    stroke: "url(#paint88_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.908 647.659L497.46 764.619",
    stroke: "url(#paint89_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.856 647.652L569.799 541.384",
    stroke: "url(#paint90_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.796 541.428L636.075 621.914",
    stroke: "url(#paint91_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.089 621.967L580.846 647.66",
    stroke: "url(#paint92_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.854 647.711L647.301 735.778",
    stroke: "url(#paint93_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.311 735.83L497.492 764.62",
    stroke: "url(#paint94_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.505 764.699L599.692 815.991",
    stroke: "url(#paint95_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.677 816.071L695.36 779.285",
    stroke: "url(#paint96_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.348 779.247L647.303 735.867",
    stroke: "url(#paint97_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.336 735.83L605.325 816.367",
    stroke: "url(#paint98_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.059 778.764L190.131 762.843",
    stroke: "url(#paint99_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.059 778.768L312.894 604.306",
    stroke: "url(#paint100_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.033 779.06L691.307 690.68",
    stroke: "url(#paint101_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.297 690.681L647.278 735.83",
    stroke: "url(#paint102_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.301 735.822L636.075 621.975",
    stroke: "url(#paint103_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.071 622.009L691.278 690.637",
    stroke: "url(#paint104_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.043 621.966L689.543 557.027",
    stroke: "url(#paint105_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.515 557.027L691.278 690.68",
    stroke: "url(#paint106_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.311 690.68L190.103 762.545",
    stroke: "url(#paint107_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.518 557.06L731.481 601.029",
    stroke: "url(#paint108_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.476 557.027L727.284 460.722",
    stroke: "url(#paint109_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.52 556.991L644.095 465.101",
    stroke: "url(#paint110_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.122 465.066L569.759 541.376",
    stroke: "url(#paint111_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.798 541.463L689.52 556.94",
    stroke: "url(#paint112_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.061 465.066L702.587 386.081",
    stroke: "url(#paint113_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.547 386.099L727.239 460.702",
    stroke: "url(#paint114_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.246 460.722L642.066 468.144",
    stroke: "url(#paint115_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.519 386.08L730.458 314.295",
    stroke: "url(#paint116_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.551 314.296L314.671 601.844",
    stroke: "url(#paint117_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.549 386.108L745.372 388.287",
    stroke: "url(#paint118_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.551 386.032L598.036 385.015",
    stroke: "url(#paint119_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.032 385.003L644.091 465.03",
    stroke: "url(#paint120_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.091 464.994L545.561 451.313",
    stroke: "url(#paint121_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.561 451.259L569.794 541.358",
    stroke: "url(#paint122_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.845 541.376L389.179 657.887",
    stroke: "url(#paint123_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.142 657.887L545.654 451.241",
    stroke: "url(#paint124_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.559 451.228L527.905 358.414",
    stroke: "url(#paint125_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.532 451.241L598.061 384.967",
    stroke: "url(#paint126_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.004 384.967L605.836 316.914",
    stroke: "url(#paint127_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.8 316.915L652.454 301.542",
    stroke: "url(#paint128_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.451 301.581L702.551 386.041",
    stroke: "url(#paint129_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.448 301.6L730.426 314.238",
    stroke: "url(#paint130_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.426 314.271L698.365 228.402",
    stroke: "url(#paint131_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.424 301.543L696.463 234.027",
    stroke: "url(#paint132_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.45 301.487L580.316 251.468",
    stroke: "url(#paint133_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.303 251.412L623.278 224.458",
    stroke: "url(#paint134_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.316 251.432L605.809 316.896",
    stroke: "url(#paint135_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.828 316.915L527.892 358.401",
    stroke: "url(#paint136_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.891 662.157C385.524 662.036 383.705 659.999 383.828 657.609C383.951 655.218 385.97 653.379 388.338 653.501C390.705 653.623 392.524 655.66 392.402 658.05C392.279 660.441 390.259 662.279 387.891 662.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.634 651.987C578.267 651.865 576.447 649.83 576.571 647.44C576.694 645.049 578.713 643.211 581.08 643.332C583.448 643.453 585.268 645.49 585.144 647.879C585.022 650.269 583.002 652.108 580.634 651.987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.689 362.729C525.32 362.608 523.501 360.571 523.625 358.18C523.748 355.791 525.768 353.952 528.135 354.074C530.503 354.195 532.321 356.23 532.199 358.621C532.075 361.012 530.057 362.85 527.689 362.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.345 455.569C542.976 455.448 541.158 453.412 541.281 451.021C541.403 448.632 543.422 446.793 545.79 446.913C548.159 447.035 549.978 449.071 549.855 451.462C549.731 453.851 547.711 455.691 545.345 455.569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.587 321.242C603.219 321.121 601.401 319.085 601.523 316.694C601.646 314.306 603.666 312.465 606.033 312.587C608.402 312.707 610.221 314.745 610.097 317.134C609.973 319.525 607.955 321.365 605.587 321.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.814 389.295C595.445 389.174 593.627 387.137 593.75 384.747C593.873 382.357 595.893 380.518 598.26 380.641C600.629 380.762 602.446 382.798 602.324 385.188C602.2 387.577 600.182 389.416 597.814 389.295Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.228 305.87C649.86 305.748 648.041 303.714 648.164 301.323C648.287 298.933 650.307 297.094 652.673 297.215C655.042 297.336 656.861 299.373 656.738 301.762C656.615 304.153 654.595 305.992 652.228 305.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.329 390.407C699.961 390.286 698.143 388.25 698.265 385.859C698.388 383.47 700.407 381.632 702.775 381.754C705.143 381.875 706.963 383.911 706.84 386.299C706.715 388.69 704.697 390.529 702.329 390.407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.876 469.394C641.509 469.273 639.69 467.236 639.813 464.846C639.936 462.457 641.955 460.617 644.323 460.738C646.692 460.86 648.51 462.896 648.386 465.286C648.263 467.676 646.243 469.517 643.876 469.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.024 465.049C724.657 464.928 722.838 462.893 722.961 460.501C723.084 458.111 725.103 456.273 727.471 456.394C729.839 456.516 731.658 458.552 731.535 460.942C731.412 463.332 729.393 465.171 727.024 465.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.206 318.623C727.838 318.502 726.019 316.466 726.142 314.076C726.265 311.686 728.284 309.848 730.652 309.969C733.02 310.09 734.839 312.126 734.714 314.515C734.592 316.906 732.573 318.744 730.206 318.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.095 255.74C577.727 255.619 575.909 253.583 576.032 251.192C576.154 248.802 578.174 246.964 580.541 247.085C582.909 247.207 584.729 249.244 584.605 251.634C584.482 254.022 582.462 255.861 580.095 255.74Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.297 561.353C686.93 561.232 685.111 559.196 685.234 556.807C685.357 554.415 687.377 552.578 689.745 552.699C692.112 552.821 693.931 554.856 693.808 557.247C693.685 559.636 691.665 561.475 689.297 561.353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.063 695.009C688.695 694.887 686.876 692.851 686.999 690.46C687.123 688.071 689.143 686.232 691.51 686.353C693.878 686.474 695.696 688.511 695.574 690.901C695.451 693.291 693.431 695.129 691.063 695.009Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.077 740.157C644.711 740.035 642.891 738.001 643.014 735.61C643.137 733.219 645.156 731.382 647.525 731.503C649.892 731.625 651.712 733.66 651.59 736.051C651.465 738.44 649.445 740.278 647.077 740.157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.852 626.293C633.484 626.172 631.665 624.137 631.789 621.745C631.911 619.356 633.93 617.517 636.298 617.638C638.667 617.761 640.486 619.796 640.363 622.187C640.239 624.576 638.219 626.414 635.852 626.293Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.579 545.702C567.212 545.58 565.392 543.546 565.515 541.155C565.637 538.766 567.657 536.926 570.025 537.048C572.394 537.169 574.213 539.206 574.09 541.595C573.966 543.985 571.947 545.825 569.579 545.702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.289 768.946C494.922 768.824 493.103 766.789 493.226 764.398C493.35 762.008 495.368 760.171 497.737 760.291C500.105 760.414 501.923 762.449 501.801 764.84C501.678 767.229 499.659 769.067 497.289 768.946Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.845 783.388C688.477 783.268 686.658 781.231 686.781 778.842C686.904 776.451 688.924 774.613 691.29 774.735C693.659 774.855 695.478 776.89 695.355 779.281C695.231 781.673 693.213 783.51 690.845 783.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.507 801.778L473.015 790.008",
    stroke: "url(#paint137_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.066 790.008L377.044 924.593",
    stroke: "url(#paint138_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.012 789.999L460.288 667.718",
    stroke: "url(#paint139_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.291 667.768L536.559 760.385",
    stroke: "url(#paint140_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.568 760.444L472.998 790.008",
    stroke: "url(#paint141_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.012 790.067L549.473 891.407",
    stroke: "url(#paint142_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.49 891.468L377.094 924.593",
    stroke: "url(#paint143_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.104 924.685L494.692 983.709",
    stroke: "url(#paint144_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.674 983.8L604.777 941.47",
    stroke: "url(#paint145_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.762 941.427L549.475 891.511",
    stroke: "url(#paint146_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.515 891.468L501.175 984.141",
    stroke: "url(#paint147_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.817 941.213L640.449 919.772",
    stroke: "url(#paint148_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.832 941.242L636.583 995.329",
    stroke: "url(#paint149_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.797 941.214L600.113 839.514",
    stroke: "url(#paint150_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.107 839.513L549.453 891.467",
    stroke: "url(#paint151_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.473 891.458L536.556 760.453",
    stroke: "url(#paint152_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.557 760.495L600.083 839.464",
    stroke: "url(#paint153_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.521 760.445L598.082 685.718",
    stroke: "url(#paint154_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.053 685.718L600.083 839.513",
    stroke: "url(#paint155_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.078 839.514L633.587 825.891",
    stroke: "url(#paint156_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.053 685.756L646.341 736.35",
    stroke: "url(#paint157_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.005 685.718L641.51 574.9",
    stroke: "url(#paint158_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.051 685.678L545.781 579.94",
    stroke: "url(#paint159_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.817 579.899L460.246 667.708",
    stroke: "url(#paint160_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.287 667.808L598.051 685.618",
    stroke: "url(#paint161_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.743 579.9L613.089 489.011",
    stroke: "url(#paint162_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.045 489.032L641.458 574.878",
    stroke: "url(#paint163_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.463 574.901L543.446 583.44",
    stroke: "url(#paint164_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.015 489.01L645.166 406.407",
    stroke: "url(#paint165_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.131 406.429L672.7 428.821",
    stroke: "url(#paint166_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.049 489.042L662.325 491.55",
    stroke: "url(#paint167_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.051 488.955L492.784 487.786",
    stroke: "url(#paint168_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.778 487.772L545.778 579.859",
    stroke: "url(#paint169_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.778 579.817L432.4 564.073",
    stroke: "url(#paint170_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.403 564.013L460.286 667.688",
    stroke: "url(#paint171_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.349 667.708L252.459 801.778",
    stroke: "url(#paint172_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.413 801.779L432.51 563.991",
    stroke: "url(#paint173_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.403 563.976L412.088 457.175",
    stroke: "url(#paint174_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.373 563.991L492.817 487.73",
    stroke: "url(#paint175_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.746 487.73L501.759 409.422",
    stroke: "url(#paint176_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.724 409.422L555.409 391.733",
    stroke: "url(#paint177_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.4 391.777L613.051 488.965",
    stroke: "url(#paint178_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.399 391.799L645.13 406.341",
    stroke: "url(#paint179_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.13 406.379L608.236 307.57",
    stroke: "url(#paint180_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.368 391.733L606.044 314.043",
    stroke: "url(#paint181_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.395 391.668L472.393 334.113",
    stroke: "url(#paint182_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.365 334.049L600.106 261.884",
    stroke: "url(#paint183_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.398 334.071L501.731 409.4",
    stroke: "url(#paint184_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.745 409.422L412.065 457.16",
    stroke: "url(#paint185_radial_19794_62913)",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.962 806.69C248.239 806.551 246.144 804.206 246.286 801.456C246.428 798.706 248.752 796.59 251.476 796.731C254.2 796.871 256.294 799.214 256.152 801.963C256.011 804.715 253.687 806.831 250.962 806.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.012 767.458C187.661 768.029 184.874 765.253 185.225 762.005C185.476 759.66 187.417 757.752 189.746 757.575C193.065 757.326 195.678 760.337 194.951 763.657C194.527 765.589 192.945 767.129 191.012 767.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.777 608.924C310.426 609.496 307.64 606.72 307.99 603.471C308.241 601.125 310.182 599.216 312.513 599.04C315.832 598.791 318.444 601.802 317.716 605.122C317.295 607.054 315.71 608.595 313.777 608.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.751 794.988C470.027 794.848 467.933 792.504 468.075 789.754C468.218 787.004 470.541 784.888 473.265 785.029C475.99 785.169 478.084 787.512 477.941 790.261C477.8 793.012 475.476 795.129 472.751 794.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.83 462.14C409.106 462 407.012 459.656 407.154 456.906C407.295 454.157 409.619 452.04 412.343 452.181C415.067 452.321 417.161 454.664 417.02 457.414C416.877 460.165 414.554 462.281 411.83 462.14Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.141 568.97C429.417 568.829 427.324 566.487 427.465 563.736C427.607 560.986 429.931 558.87 432.654 559.009C435.379 559.15 437.474 561.495 437.332 564.244C437.189 566.994 434.866 569.111 432.141 568.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.47 414.402C498.746 414.261 496.652 411.917 496.795 409.167C496.936 406.417 499.26 404.301 501.983 404.441C504.708 404.582 506.802 406.925 506.66 409.674C506.518 412.425 504.194 414.542 501.47 414.402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.526 492.709C489.803 492.57 487.708 490.226 487.851 487.476C487.993 484.726 490.315 482.61 493.039 482.75C495.764 482.89 497.858 485.233 497.715 487.983C497.574 490.735 495.251 492.85 492.526 492.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.143 396.713C552.42 396.573 550.325 394.229 550.467 391.479C550.609 388.73 552.932 386.613 555.656 386.754C558.38 386.894 560.474 389.237 560.332 391.986C560.192 394.738 557.868 396.852 555.143 396.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.791 493.99C610.067 493.85 607.973 491.506 608.116 488.755C608.257 486.005 610.581 483.89 613.305 484.03C616.029 484.17 618.123 486.513 617.98 489.263C617.84 492.014 615.515 494.13 612.791 493.99Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.525 584.879C542.801 584.739 540.707 582.395 540.849 579.645C540.991 576.896 543.314 574.779 546.038 574.919C548.762 575.061 550.856 577.402 550.715 580.152C550.573 582.904 548.25 585.018 545.525 584.879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.204 579.88C638.481 579.738 636.388 577.397 636.528 574.645C636.67 571.895 638.994 569.78 641.718 569.919C644.442 570.059 646.537 572.404 646.395 575.154C646.252 577.904 643.929 580.02 641.204 579.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.869 411.388C642.145 411.247 640.052 408.905 640.192 406.154C640.335 403.404 642.657 401.288 645.382 401.428C648.107 401.569 650.201 403.912 650.059 406.662C649.917 409.412 647.593 411.528 644.869 411.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.135 339.028C469.41 338.887 467.317 336.544 467.459 333.792C467.601 331.042 469.924 328.928 472.648 329.068C475.373 329.208 477.467 331.551 477.324 334.301C477.184 337.05 474.859 339.169 472.135 339.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.798 690.698C595.074 690.557 592.98 688.215 593.122 685.463C593.265 682.713 595.588 680.599 598.311 680.739C601.036 680.879 603.13 683.22 602.988 685.972C602.847 688.721 600.523 690.838 597.798 690.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.821 844.492C597.097 844.351 595.004 842.008 595.145 839.259C595.287 836.507 597.611 834.392 600.334 834.533C603.059 834.674 605.153 837.016 605.012 839.765C604.869 842.517 602.546 844.632 599.821 844.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.214 896.447C546.489 896.306 544.395 893.963 544.539 891.213C544.68 888.461 547.003 886.347 549.727 886.488C552.452 886.629 554.545 888.97 554.402 891.72C554.263 894.472 551.938 896.588 549.214 896.447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.299 765.423C533.574 765.283 531.481 762.941 531.623 760.189C531.765 757.44 534.088 755.325 536.812 755.464C539.537 755.604 541.63 757.947 541.488 760.698C541.348 763.448 539.023 765.563 536.299 765.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.025 672.687C457.302 672.548 455.207 670.205 455.349 667.454C455.492 664.703 457.814 662.588 460.538 662.728C463.263 662.869 465.356 665.211 465.215 667.962C465.074 670.712 462.751 672.828 460.025 672.687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.846 929.573C374.122 929.432 372.029 927.089 372.17 924.34C372.312 921.588 374.635 919.473 377.36 919.614C380.083 919.755 382.178 922.096 382.035 924.847C381.894 927.598 379.571 929.713 376.846 929.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.571 946.191C596.848 946.052 594.755 943.709 594.895 940.958C595.038 938.208 597.361 936.093 600.084 936.232C602.809 936.373 604.903 938.715 604.762 941.466C604.619 944.216 602.295 946.332 599.571 946.191Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-55.46 39.6222 -39.1908 -55.9472 153.73 922.086)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-58.8677 41.937 -41.5981 -59.2168 116.493 977.908)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-30.5909 21.8542 -21.6171 -30.8584 254.88 957.711)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-30.1349 21.5109 -21.2947 -30.374 281.95 971.682)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-17.6745 12.622 -12.4897 -17.8226 244.058 1008.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-31.8533 22.7432 -22.509 -32.114 203.273 1048.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-63.7727 45.5562 -45.065 -64.326 102.67 1033.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-48.7852 34.8514 -34.474 -49.2107 56.752 1039.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.6633 21.1866 -20.9615 -29.9158 141.613 1140.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-18.8502 13.413 -13.32 -18.9401 187.537 1134.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-26.1143 18.6098 -18.4534 -26.2778 145.277 1110.56)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-11.6248 8.30062 -8.21467 -11.7206 201.195 1172.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-16.4609 11.7555 -11.6321 -16.599 174.622 1191.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-25.2751 18.055 -17.8606 -25.4939 217.451 1136.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-18.2449 12.9845 -12.8924 -18.3348 220.716 1105.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-32.75 23.3966 -23.1428 -33.0363 230.343 1062.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-25.4729 18.1845 -18.0003 -25.677 261.5 1066.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-24.2715 17.1371 -17.1501 -24.2 312.908 1024.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-38.2227 27.3044 -27.0101 -38.5542 303.279 1067.22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.17189 6.55067 -6.48131 -9.24965 265.483 1117.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-88.885 63.5006 -62.8106 -89.6638 272.41 893.857)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.6845 21.1806 -20.9764 -29.9076 403.79 1010.35)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-29.5134 21.0829 -20.8556 -29.7694 376.374 978.687)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-30.7314 21.8707 -21.7158 -30.8826 345.419 926.324)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-34.9019 24.934 -24.6635 -35.2072 323.728 972.804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.3162 19.8023 -20.0065 -27.966 446.859 930.974)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-22.5978 16.1444 -15.9687 -22.7961 474.272 962.633)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-24.7335 17.6702 -17.478 -24.9506 423.66 964.014)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-22.1223 15.7852 -15.6326 -22.289 532.173 918.598)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-30.207 21.5808 -21.3458 -30.4724 463.743 887.911)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-26.6259 19.0183 -18.8151 -26.8542 414.951 889.144)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.767 20.5511 -20.3282 -29.0185 372.958 888.819)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-26.7865 19.1372 -18.9287 -27.0219 320.312 882.936)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-62.0014 44.2568 -43.8131 -62.4917 191.62 884.815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-74.4617 51.4573 -52.6046 -72.6807 219.165 847.311)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-27.0905 19.3542 -19.1435 -27.3284 378.473 809.702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-24.388 17.0917 -17.2314 -24.1375 389.846 845.756)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-19.597 13.9966 -13.8482 -19.7635 460.694 828.113)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-14.2649 10.1892 -10.0803 -14.3874 509.959 823.902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-28.3152 20.2245 -20.0089 -28.5573 513.003 883.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-22.8559 16.3279 -16.1511 -23.0552 549.533 872.557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-25.5705 18.167 -18.0685 -25.6534 527.534 793.519)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-20.2322 14.4541 -14.2971 -20.4094 507.129 779.762)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-25.5553 18.2474 -18.0586 -25.7656 449.325 792.059)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(67.2178 11.5498 -11.5542 67.6112 562.828 296.01)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(49.873 8.60106 -8.57189 50.3549 621.657 247.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(36.9029 6.26597 -6.34472 36.671 516.234 198.542)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(36.3136 6.2614 -6.24141 36.6572 506.866 169.319)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.3516 3.68092 -3.66984 21.5496 559.741 170.041)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(38.3943 6.61966 -6.59903 38.7546 616.35 171.124)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(53.5287 9.18708 -9.20139 53.7784 668.898 219.841)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.9318 6.88687 -6.86326 40.3191 705.513 248.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(35.8456 6.17772 -6.16108 36.1666 724.393 150.062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.6432 3.90492 -3.89178 22.8613 687.778 121.443)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(31.5207 5.43535 -5.41762 31.8212 700.682 168.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.0407 2.4209 -2.41326 14.173 704.158 85.3663)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(19.8447 3.42111 -3.41083 20.0288 736.238 90.9245)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.494 5.24128 -5.24148 30.6829 667.819 98.8493)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.0272 3.79898 -3.78591 22.2411 644.001 118.256)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(39.5076 6.72191 -6.79225 39.3414 606.984 141.902)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.6977 5.29297 -5.27618 30.9876 587.39 117.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(29.3018 5.05353 -5.03622 29.5859 521.617 110.172)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(46.1145 7.92193 -7.9265 46.3752 558.638 86.5272)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(11.0823 1.91014 -1.90479 11.1827 620.312 78.2231)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(21.2571 3.66564 -3.65356 21.4604 516.977 61.0712)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(35.8263 6.17671 -6.15767 36.1613 447.771 54.9208)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(35.5927 6.133 -6.11757 35.905 445.003 96.8949)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(37.1022 6.39894 -6.37693 37.4626 430.253 156.042)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(42.1524 7.26551 -7.24506 42.5351 478.11 138.674)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.1827 5.89518 -5.87513 34.5133 361.777 80.2735)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.2566 4.69099 -4.6849 27.4622 364.549 38.2985)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.0734 5.15155 -5.16974 30.1538 401.299 73.4857)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(26.6996 4.60317 -4.589 26.9491 292.793 28.0619)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(36.5324 6.28982 -6.2793 36.8219 319.708 98.6575)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.1066 5.53379 -5.51837 32.3972 355.068 132.648)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.7407 5.98828 -5.97115 35.0577 384.532 162.884)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.311 5.55453 -5.55378 32.5168 417.643 204.663)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(74.8734 12.9117 -12.8689 75.591 509.956 295.287)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(89.8863 15.502 -15.4492 90.7564 464.239 302.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(32.6788 5.59436 -5.61747 32.747 325.274 214.886)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(29.4413 5.07756 -5.06021 29.7266 342.46 181.269)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(23.6463 4.07197 -4.0643 23.8386 280.018 143.117)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(17.2441 2.9708 -2.96392 17.392 242.235 110.895)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(34.1429 5.88502 -5.86835 34.4535 281.926 66.4352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.5983 4.7576 -4.74351 27.8529 248.3 48.2141)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.6718 5.28983 -5.27169 30.9693 208.551 119.821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(24.4026 4.20231 -4.19429 24.6017 213.347 144.129)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(30.866 5.32198 -5.30513 31.1572 262.825 176.734)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.53337 67.5627 -67.7884 -3.43801 485.04 652.773)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.63224 51.0235 -50.5477 -2.59366 539.184 706.139)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.95659 37.7872 -37.5601 -1.92154 575.327 594.518)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.91668 37.153 -36.8067 -1.88858 602.936 581.671)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.12552 21.8001 -21.6128 -1.10821 608.467 634.813)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.02665 39.2848 -38.9184 -1.99695 614.078 691.744)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.8085 54.2661 -53.9215 -2.7591 572.402 750.225)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.10635 40.8056 -40.4478 -2.07432 548.598 790.345)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.88887 36.5728 -36.2702 -1.85922 647.519 797.678)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.19488 23.1598 -22.9457 -1.17727 671.325 757.557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.66416 32.2558 -31.957 -1.63967 626.331 776.099)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.22414 176.394 -176.968 -8.97597 440.595 770.804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-7.65583 148.296 -147.012 -7.53859 501.977 691.537)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.65139 31.2244 -31.6509 -1.59079 691.17 734.871)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.16224 22.5279 -22.3189 -1.14515 669.288 713.256)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.09529 40.4545 -40.2216 -2.05724 641.688 678.899)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.62034 31.4089 -31.116 -1.59659 663.675 656.323)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.54628 29.973 -29.6937 -1.5236 662.793 589.496)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.56188 47.2199 -49.0285 -2.41056 690.397 623.853)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.31325 179.695 -178.791 -9.13737 440.707 726.613)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.12187 21.7459 -21.5437 -1.1054 710.499 579.044)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.89213 36.668 -36.334 -1.86399 708.38 508.874)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.87958 36.4294 -36.0936 -1.85184 666.808 511.046)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.95766 37.9457 -37.5937 -1.92888 606.941 503.221)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.22176 42.8812 -42.6532 -2.18043 629.659 549.201)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.80402 34.9694 -34.6432 -1.77758 673.324 425.573)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.44016 27.9026 -27.6543 -1.41845 714.893 423.401)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.57523 30.2854 -30.233 -1.54042 684.656 464.433)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.41013 27.3271 -27.0783 -1.38915 716.489 350.188)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.27281 179.692 -178.067 -9.13435 522.611 458.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.78899 15.1431 -15.141 -0.770333 723.961 387.198)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.92565 36.4928 -36.919 -1.85849 650.293 385.524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.6952 32.8583 -32.5533 -1.67029 621.061 425.016)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.83114 35.3533 -35.1549 -1.79761 594.826 458.154)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.70781 33.0786 -32.7929 -1.68162 557.677 496.309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.94871 76.5147 -75.8272 -3.8895 479.512 599.632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.74383 91.9549 -91.0974 -4.6743 467.398 554.564)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.7287 33.4594 -33.1919 -1.7011 536.732 404.821)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.55372 30.1174 -29.8366 -1.53094 571.797 418.104)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.25212 24.2093 -24.0391 -1.23095 601.919 350.941)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.908325 17.5813 -17.4413 -0.893787 629.127 309.229)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.80266 34.9414 -34.6167 -1.77618 677.501 343.811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.45479 28.105 -27.9308 -1.42898 691.438 307.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.67947 32.5437 -32.2501 -1.65435 714.396 271.336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.4796 28.6804 -28.4131 -1.4579 674.444 267.785)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.61827 31.3607 -31.0758 -1.59416 616.383 276.478)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.93839 18.1828 -18.0199 -0.924297 601.791 237.936)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.28904 24.9792 -24.753 -1.26981 593.063 284.164)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.62743 31.5279 -31.2512 -1.6027 566.86 337.658)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.06556 77.7395 -77.9985 -3.9559 362.761 795.893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.02767 58.6883 -58.1409 -2.98332 425.055 857.301)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.25105 43.4737 -43.2125 -2.21074 466.65 728.859)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.20422 42.7264 -42.3281 -2.17192 498.425 714.076)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.29402 25.0636 -24.8482 -1.27412 504.783 775.226)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.33072 45.1786 -44.7573 -2.29658 511.243 840.737)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-3.23109 62.4313 -62.0347 -3.17429 463.292 908.031)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.4228 46.9358 -46.5241 -2.38598 435.898 954.197)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.17251 42.0647 -41.7165 -2.13843 549.725 962.635)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.37363 26.6243 -26.3781 -1.3534 577.119 916.469)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.91389 37.0961 -36.7524 -1.88574 525.345 937.804)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.850688 16.4799 -16.3355 -0.837755 620.133 930.493)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.20418 23.3415 -23.124 -1.18653 618.207 968.286)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.90012 35.9278 -36.4182 -1.83042 599.955 890.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.33605 25.8967 -25.6564 -1.31641 574.78 865.49)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.41063 46.5426 -46.2747 -2.36686 543.015 825.956)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.86314 36.1152 -35.7784 -1.83585 568.32 799.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.77799 34.4643 -34.1432 -1.75193 567.301 723.082)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.94762 54.3321 -56.4108 -2.7736 599.068 762.616)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.671004 12.9935 -12.8847 -0.660545 616.833 832.702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.28957 24.9962 -24.7639 -1.27064 622.197 711.053)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.17645 42.1778 -41.7936 -2.1441 619.758 630.309)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.16167 41.8965 -41.5103 -2.12978 571.916 632.809)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.25133 43.6376 -43.2328 -2.21824 503.031 623.803)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.55638 49.3395 -49.0769 -2.50886 529.169 676.713)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.07464 40.2149 -39.8398 -2.04425 579.416 534.455)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.65627 32.0896 -31.804 -1.63131 627.252 531.955)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.81226 34.8426 -34.7822 -1.77223 592.455 579.171)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.62181 31.4291 -31.1431 -1.5977 629.091 447.709)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.659702 12.7859 -12.6684 -0.649951 658.915 417.625)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-0.907881 17.4252 -17.4226 -0.886436 637.687 490.296)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.21573 41.9894 -42.4804 -2.13841 552.918 488.371)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.94941 37.7854 -37.4347 -1.92077 519.278 533.815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.10686 40.6764 -40.448 -2.0683 489.089 571.945)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.96434 38.047 -37.7185 -1.93423 446.344 615.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-4.5425 88.0202 -87.2292 -4.47443 356.403 734.743)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-5.45747 105.788 -104.801 -5.37753 342.461 682.885)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.98856 38.4888 -38.1811 -1.95683 422.245 510.576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.78656 34.6307 -34.3078 -1.76039 462.595 525.861)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.44066 27.8543 -27.6585 -1.4163 497.253 448.576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.04429 20.2129 -20.052 -1.02759 528.567 400.577)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.07306 40.1824 -39.8091 -2.04262 584.226 440.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.67374 32.3348 -32.1343 -1.64407 600.264 399.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.93156 37.4283 -37.0906 -1.90268 626.683 356.975)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.70138 32.9792 -32.6719 -1.67645 580.706 352.888)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.86089 36.0625 -35.7348 -1.83319 513.894 362.891)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-2.6987 52.285 -51.8224 -2.65789 536.235 297.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.48225 28.7232 -28.463 -1.46015 487.065 371.735)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_19794_62913",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-1.87149 36.2557 -35.9375 -1.84305 456.905 433.291)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275937);
export default __webpack_public_path__ + "static/media/Group 1171275937.ed50eb9e5c533ffc23869e2c74f314cd.svg";
export { ForwardRef as ReactComponent };